<form class="itinerary-model-content-inner" >
  <div class="itinerary-model-content">
    <div class="box-title-container mb-1">
      <div class="">
        <div class="d-flex align-items-center">
          <div class="icon-container">
            <ion-icon name="person"></ion-icon>
          </div>
          <div>
            <p class="title">Lead Information</p>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="!showLeadForm">
      <form [formGroup]="leadServicesForm">
        <div class="form-container ion-padding-horizontal">
          <!-- Lead form -->
    
          <div class="row lead-info-row">
            <div class="col-4">
              <div class="grid-container">
                <b class="label">Lead ID</b><p class="value">{{ leadDetails.leadId }}</p>
                <b class="label">Name</b><p class="value">{{ leadDetails.firstName }} {{ leadDetails.lastName }}</p>
                <b class="label">Owner</b><p class="value">{{ leadDetails.ownershipName }} <span *ngIf="!leadDetails.ownership">--</span></p>
              </div>
            </div>
            <div class="col-4">
              <div class="grid-container">
                <b class="label">Phone</b><p class="value">{{ leadDetails.phoneNumber.countryCode }} {{leadDetails.phoneNumber.phone}}</p>
                <b class="label">Email</b><p class="value">{{ leadDetails.email }}<span *ngIf="!leadDetails.email">--</span></p>
              </div>
            </div>
            <div class="col-4">
              <div class="grid-container">
                <b class="label">Source</b><p class="value">{{ leadDetails.source }}<span *ngIf="!leadDetails.source">--</span></p>
                <b class="label">Status</b><p class="value">{{ leadDetails.status }}<span *ngIf="!leadDetails.status">--</span></p>
                <b class="label">Priority</b><p class="value">{{ leadDetails.priority }}<span *ngIf="!leadDetails.priority">--</span></p>
              </div>
            </div>
          </div>
          
    
          <!-- <div class="dashed-line mt-3"></div> -->
    
          <!-- Service types -->
    
          <div class="row mt-2">
            <div class="col">
              <div class="input-container service-container w-100">
                <!-- <label for="" class="label ms-0">Select Service Types* <span style="font-size: 12px;" class="text-danger clickable-text me-3" (click)="clearServices()">Clear Services </span>  <span class="text-danger warning-message" *ngIf="leadServicesForm.get('travelServices')?.invalid && leadServicesForm.get('travelServices')?.touched">This field is required</span></label> -->
                <div class="d-flex justify-content-between align-items-center">
                  <label for="" class="label">Select Service Types*<span class="text-danger warning-message" *ngIf="leadServicesForm.get('travelServices')?.invalid && leadServicesForm.get('travelServices')?.touched">Select at least 1 service</span></label>
    
                   <ion-button class="clear-service-btn" (click)="clearServices()" [disabled]="leadServicesForm.get('travelServices')?.value?.length === 0">Clear Services</ion-button>
                </div>
                <app-travel-service-input
                [data]="travelServices"
                [disableServiceType]="disableServiceType"
                formControlName="travelServices"
                [hideVisa]="true"
                ></app-travel-service-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="input-container">
                <label for="" class="label">Lead Notes*</label>
                <div>
                  <textarea class="input input-textarea" name="" formControlName="leadNote" id="" placeholder="Add lead notes here"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </ng-container>

    <ng-container *ngIf="showLeadForm">
      <app-lead-form [showOnlyForm]="true" [hideVisaService]="true" (emitLeadId)="leadCreated($event)"></app-lead-form>
    </ng-container>
    
  </div>
  
  <div class="ion-padding-horizontal justify-content-between itinerary-model-footer">
    <div class="d-flex align-items-center">
      <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
        Reset
      </ion-button>
    </div>
    
    <div class="d-flex align-items-center">
      <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified()">
        Save
      </ion-button>
      <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified()">
        Save & Next
      </ion-button>
      <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="formDataModified()">
        <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </div>
  </div>
</form>
